module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABPElEQVQokY3SsWpVQRAG4C96LCwCEVOYIsUNiCiIRcA0xioEgpWNb2ApeQE7fQEfwFpIZee1ChrsgiDEBFJEiRdEjaSxMWB+i8wBvZxjHBh2dvb/59/ZnYkkxmwBD3ATh1jEEdZwA3v4hafNH6QGL7CEt9jA+wLCG7zD49qPWvJ5jCq+jq3x6+AJHuETfiCSSLKbZFRxnz/PiV1M8irJZoP7uIzJDrXWXmK5cN/xDEeS7CdZ61FrkqyX4mD8XJKfSe71kB8W8VLXuSTHSW71kOeSTHXk55NsNzjGdE+vez35K7h6Bt9w9x+P1WUr+CzJavV19pSvav1c4Vcnajy/4gDX/kN1B1OYaatNV7XtJLM9irM1TElyIYl2PA+cPNoQ+3hd/gED3C7fLNwhdCncSTJM8jHJl1qHlf8L+xtECYBBhyN40gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_share.png
// module id = OqSu
// module chunks = 1